let modals = [];

const MANAGED_INERT_ATTR = 'data-modal-managed-inert';

const clear_managed_inert = (root) => {
    if (!(root instanceof HTMLElement)) {
        return;
    }

    root.removeAttribute('inert');

    root.querySelectorAll(`[${MANAGED_INERT_ATTR}]`).forEach((el) => {
        if (!(el instanceof HTMLElement)) {
            return;
        }

        el.removeAttribute('inert');
        el.removeAttribute(MANAGED_INERT_ATTR);
    });
};

const isolate_modal_branch = (app_content, modal) => {
    let current = modal;

    while (
        current instanceof HTMLElement &&
        current !== app_content &&
        current.parentElement instanceof HTMLElement
    ) {
        Array.from(current.parentElement.children).forEach((sibling) => {
            if (!(sibling instanceof HTMLElement) || sibling === current) {
                return;
            }

            sibling.setAttribute('inert', '');
            sibling.setAttribute(MANAGED_INERT_ATTR, '');
        });

        current = current.parentElement;
    }
};

export const sync_modal_state = () => {
    if (typeof document === 'undefined') {
        return;
    }

    const app_content = document.querySelector('#app-content');
    const has_modal = modals.length > 0;
    const top_modal = modals[modals.length - 1];

    if (app_content instanceof HTMLElement) {
        clear_managed_inert(app_content);

        if (has_modal) {
            if (
                top_modal instanceof HTMLElement &&
                app_content.contains(top_modal)
            ) {
                isolate_modal_branch(app_content, top_modal);
            } else {
                app_content.setAttribute('inert', '');
            }
        }
    }

    if (has_modal) {
        document.body.classList.add('has-modal');
    } else {
        document.body.classList.remove('has-modal');
    }

    modals.forEach((modal, index) => {
        if (!(modal instanceof HTMLElement)) {
            return;
        }

        if (index === modals.length - 1) {
            modal.removeAttribute('inert');
        } else {
            modal.setAttribute('inert', '');
        }
    });
};

export const register_modal = (modal) => {
    if (!(modal instanceof HTMLElement)) {
        return;
    }

    if (!modals.includes(modal)) {
        modals = [...modals, modal];
    }

    sync_modal_state();
};

export const unregister_modal = (modal) => {
    if (!(modal instanceof HTMLElement)) {
        return;
    }

    modals = modals.filter((item) => item !== modal);
    sync_modal_state();
};

export const is_top_modal = (modal) => modal === modals[modals.length - 1];
